import { filterEffects } from "./filter-effects/filter-effects-db.js";
import { particleEffects } from "./particle-effects/particle-effects-db.js";

export const FXMASTER = {
  filterEffects,
  particleEffects,
};
